import { ZeszytOnlineService } from '../zeszyt-online.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { GrupaDziekanskaDto } from '@enauka/api-strona-glowna';
import { LocalStorageService } from '@enauka/shared/ui';

@Component({
  selector: 'enauka-logowanie-zeszyt',
  templateUrl: './logowanie-zeszyt.component.html',
  styleUrls: ['./logowanie-zeszyt.component.css']
})
export class LogowanieZeszytComponent implements OnInit {
  grupaDziekanska: GrupaDziekanskaDto;
  kurs: string;

  constructor(
    private route: ActivatedRoute,
    private zeszytOnlineService: ZeszytOnlineService,
    private localStorageService: LocalStorageService
  ) {
    this.route.queryParamMap.subscribe(params => {
      const kurs = params.get('kurs');
      if (kurs) {
        this.localStorageService.setItem('hashKursu', kurs);
        this.zeszytOnlineService.getGrupyDziekanskie(kurs).subscribe((grupa) => {
          this.grupaDziekanska = grupa;
          this.kurs = kurs;
        });
      }
    });
  }

  ngOnInit(): void {
  }

}
